namespace TabAurous.HR {
    export interface LeaveAllocationRow {
        LeaveAllocationId?: number;
        LeaveTypeId?: number;
        EmployeeId?: number;
        FromDate?: string;
        ToDate?: string;
        Leaves?: number;
    }

    export namespace LeaveAllocationRow {
        export const idProperty = 'LeaveAllocationId';
        export const localTextPrefix = 'HR.LeaveAllocation';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            LeaveAllocationId = "LeaveAllocationId",
            LeaveTypeId = "LeaveTypeId",
            EmployeeId = "EmployeeId",
            FromDate = "FromDate",
            ToDate = "ToDate",
            Leaves = "Leaves"
        }
    }
}
